define([
	"dojo/_base/declare",
	"csi/config"
], function(declare,config) {

	return declare(null, {

		_isColorwayAttributeMappingExists: function(/*Node*/ colorNode) {
			var colorwayAttributeMap = config.getClassSetting("ColorColorwayContext", "ColorwayAttributeMap");

			if (!colorwayAttributeMap) return false;

			// check whether any source attribute in the map actually has a destination attribute
			for (var key_attr in colorwayAttributeMap) {
				if (!colorwayAttributeMap.hasOwnProperty(key_attr)) {
					continue;
				}
				if (colorwayAttributeMap[key_attr])
					return true;
			}

			return false;
		}
	});
});